import {Routes} from '@angular/router';
import {JhiResolvePagingParams} from 'ng-jhipster';
import {UserRouteAccessService} from '@app/core';
import {BaoCaoComponent} from '@entities/bao-cao/bao-cao/bao-cao.component';

export const baoCaoRoute: Routes = [
  {
    path: 'bao-cao-thong-ke',
    component: BaoCaoComponent,
    resolve: {
      pagingParams: JhiResolvePagingParams,
    },
    data: {
      authorities: ['can_report_supplies', 'can_report_activities'],
      pageTitle: 'Báo cáo thống kê',
    },
    canActivate: [UserRouteAccessService],
  },
];
